<template>
  <section class="mb-0 auto-height" id="records">
      <div class="container">
        <h3 class="text-center mb-0">工程實績</h3>
        <br>
        <div class="text-center">
            <div class="recordPicDiv align-top clickable" v-for="(record, i) in records" :key="i" @click="showIdx=i;showModal=true;">
                <img class="recordPic" :src="record.img" alt="">
                <p>{{ record.description }}</p>
            </div>
        </div>
      </div>
      <RecordModal v-if="showIdx < records.length" :record="records[showIdx]" :class="{noshow: !showModal}" @close="showModal=false" />
  </section>
</template>

<script>
import RecordModal from './RecordModal.vue'
export default {
  name: 'Records',
  components: {
    RecordModal,
  },
  props: {
    records: Array,
  },
  data() {
    return {
      showModal: false,
      showIdx: Infinity,
    }
  },
}
</script>

<style scoped>
.recordPicDiv {
  display:inline-block;
  width:100%;
}
.recordPic {
  max-width: 100%;
  margin-top: 4vh;
}
@media (min-width: 992px) {
  .recordPicDiv {
    display:inline-block;
    width:21%;
    margin-left: 2%;
    margin-right: 2%;
  }
}
</style>